import React from "react";
export const TimeCreated = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6.5" cy="6.5" r="6.125" stroke="black" strokeWidth="0.75" />
    <rect x="6" y="2" width="1" height="5" fill="black" />
    <rect
      x="9"
      y="6"
      width="1"
      height="3"
      transform="rotate(90 9 6)"
      fill="black"
    />
  </svg>
);
